"use client";
import React, { useState } from "react";

const CurriculumStructure = ({ curriculumData }) => {
  const [selectedSemester, setSelectedSemester] = useState(0);

  if (!curriculumData || !curriculumData.semesters) {
    return null;
  }

  const currentSemester = curriculumData.semesters[selectedSemester];

  return (
    <section className="bg-[#F9FAFB]  my-10 md:my-16 lg:my-24 font-sans">
      <div className="max-w-(--max-page-width) mx-auto px-(--container-padding)">

        <div className="mb-12">
          <div className="inline-block  bg-[#FFA2011A] px-3 py-1 rounded-sm mb-4">
            <span className="text-[#FFA201] text-[11px] uppercase tracking-widest ">
              {curriculumData.label}
            </span>
          </div>
          <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold text-[#111827] mb-6 tracking-tight">
            {curriculumData.heading}
          </h2>
          <p className="text-black text-base lg:text-lg max-w-3xl leading-relaxed">
            {curriculumData.description}

          </p>
        </div>

        <div className="flex gap-3 mb-10 overflow-x-auto pb-4 no-scrollbar">
          {curriculumData.semesters.map((semester, index) => (
            <button
              key={index}
              onClick={() => setSelectedSemester(index)}
              className={`px-7 py-3 rounded-full font-bold text-sm transition-all duration-200 whitespace-nowrap shadow-sm ${selectedSemester === index
                  ? "bg-[#FFA201] text-white"
                  : "bg-white text-[#4B5563] border border-gray-100 hover:bg-gray-50"
                }`}
            >
              {semester.name}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col lg:flex-row overflow-hidden">

          <div className="flex-1 p-8 lg:p-14 relative">

            <div className="absolute left-0 top-10 bottom-10 w-1 bg-[#F97316] rounded-r-full" />

            <span className="text-[#F47920] text-[12px] font-bold uppercase tracking-widest block mb-4">
              {currentSemester.name}
            </span>
            <h3 className="text-2xl lg:text-[28px] font-bold text-[#111827] mb-6 leading-snug">
              {currentSemester.title}
            </h3>
            <p className="text-[#4B5563] text-base lg:text-[17px] leading-relaxed">
              {currentSemester.description}
            </p>
          </div>

          {/* Right Column: Key Subjects Tags */}
          <div className="lg:w-[42%] bg-[#FFFFFF] p-8 lg:p-14">
            {/* <h4 className="text-[#F97316] text-[13px] font-bold uppercase tracking-widest mb-8">
              KEY SUBJECTS 
            </h4> */}
            <h4 className="text-[#F97316] text-[13px] font-bold uppercase tracking-widest mb-8">
              {currentSemester?.keySubjectsLabel ? currentSemester.keySubjectsLabel : "KEY SUBJECTS"}
            </h4>
            <div className="flex flex-wrap gap-3">
              {currentSemester.subjects?.map((subject, index) => (
                <div
                  key={index}
                  className="bg-[#EEF2FF] text-[#0A2240] px-5 py-2.5 rounded-full text-[14px] font-normal transition-colors hover:bg-[#DBEAFE]"
                >
                  {subject.name}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CurriculumStructure;

// import React, { useState } from "react";

// const CurriculumStructure = ({ curriculumData }) => {
//   const [selectedSemester, setSelectedSemester] = useState(0);

//   if (!curriculumData || !curriculumData.semesters) {
//     return null;
//   }

//   const currentSemester = curriculumData.semesters[selectedSemester];

//   return (
//     <section className="page-container bg-[#F5F5F5]">
//       <div className="py-[40px] lg:py-[80px]">
//         {/* Header Section */}
//         <div className="mb-[40px]">
//           <div className="inline-block bg-[#FFE5CC] px-[16px] py-[6px] rounded-[4px] mb-[12px]">
//             <span className="text-[#FF8C00] text-[12px] lg:text-[14px] font-semibold uppercase tracking-wide">
//               {curriculumData.label || "CURRICULUM STRUCTURE"}
//             </span>
//           </div>
//           <h2 className="mb-[12px] text-[#1A1A1A]">
//             {curriculumData.heading || "Curriculum Structure"}
//           </h2>
//           <p className="text-[#4A4A4A] w-full md:w-[80%] xl:w-[70%] text-[16px] lg:text-[18px]">
//             {curriculumData.description}
//           </p>
//         </div>

//         {/* Semester Tabs */}
//         <div className="mb-[40px] overflow-x-auto">
//           <div className="flex gap-[12px] min-w-max pb-[8px]">
//             {curriculumData.semesters.map((semester, index) => (
//               <button
//                 key={index}
//                 onClick={() => setSelectedSemester(index)}
//                 className={`px-[24px] py-[12px] rounded-full font-semibold text-[14px] lg:text-[16px] transition-all duration-300 whitespace-nowrap ${
//                   selectedSemester === index
//                     ? "bg-[#FF8C00] text-white shadow-lg"
//                     : "bg-white text-[#4A4A4A] hover:bg-[#FFE5CC] hover:text-[#FF8C00]"
//                 }`}
//               >
//                 {semester.name}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Semester Content */}
//         <div className="bg-white rounded-[16px] p-[24px] lg:p-[40px] shadow-sm">
//           <div className="mb-[24px]">
//             <div className="inline-block bg-[#E8F4FD] px-[12px] py-[4px] rounded-[4px] mb-[12px]">
//               <span className="text-[#0091E3] text-[12px] font-semibold uppercase tracking-wide">
//                 {currentSemester.name}
//               </span>
//             </div>
//             <h3 className="text-[#1A1A1A] text-[22px] lg:text-[28px] font-bold mb-[12px]">
//               {currentSemester.title}
//             </h3>
//             <p className="text-[#4A4A4A] text-[15px] lg:text-[17px] leading-relaxed w-full lg:w-[70%]">
//               {currentSemester.description}
//             </p>
//           </div>

//           {/* Key Highlights Label */}
//           {currentSemester.subjects && currentSemester.subjects.length > 0 && (
//             <div className="mb-[20px]">
//               <span className="text-[#0091E3] text-[14px] font-semibold uppercase tracking-wide">
//                 KEY HIGHLIGHTS
//               </span>
//             </div>
//           )}

//           {/* Subject Cards Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px]">
//             {currentSemester.subjects?.map((subject, index) => (
//               <div
//                 key={index}
//                 className={`${subject.bgColor} ${subject.textColor} px-[20px] py-[16px] rounded-[8px] font-medium text-[15px] lg:text-[16px] shadow-sm hover:shadow-md transition-shadow duration-300`}
//               >
//                 {subject.name}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CurriculumStructure;